import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function queueDates(id, filters) {
        return axios.get(`${endpoint}/${id}/queueDates`, { params: filters, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function createQueueDate(id, data) {
        return axios.post(`${endpoint}/${id}/queueDates`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        queueDates,
        createQueueDate
    }
}

export default service
